import { useTaskCommentsImages } from "@coworker/apprestructured/src/task-management/services/useTaskCommentsImages";
import { useUploadFiles } from "@coworker/apprestructured/src/task-management/services/useUploadFiles";
import {
  UploadImageUrl,
  useUploadImageUrls,
} from "@coworker/apprestructured/src/task-management/services/helpers/useUploadImageUrls";
import { Loading } from "@coworker/apprestructured/src/task-management/loading";

export function useTaskCommentsUploadsImageUrls(
  taskId: string | null
): UploadImageUrl[] | Loading {
  const { data: uploads } = useTaskCommentsImages(taskId);
  const uploadFiles = useUploadFiles(uploads);
  return useUploadImageUrls(uploadFiles);
}
